module.exports = __webpack_public_path__ + "/images/ico-social-instagram.ff7eba4.svg";